/* import React, { useState, useEffect, useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { yupResolver } from '@hookform/resolvers/yup'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'

import { Column, Button, Text, NumberInput, PasswordInput, Input, Link } from '../src/components'
import { createInvestor } from 'services/investor'
import { createInvestorPartner, checkCpf } from 'services/v3'
import { SignupResolver, PartnerInvestorRegister, formatCPFToNumber } from 'helpers'

const defaultValues = { document_number: '', password: '', first_name: '', last_name: '', email: '' }

const SignupInvestor = () => {
  const router = useRouter()

  const [documentNumberRegistered, setdocumentNumberRegistered] = useState(false)

  const {
    control,
    handleSubmit,
    errors,
    watch,
    formState: { isSubmitting }
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(documentNumberRegistered ? PartnerInvestorRegister : SignupResolver),
    defaultValues
  })

  const cpfValue = watch('document_number')

  const onSubmit = useCallback(
    async data => {
      try {
        if (!!documentNumberRegistered) {
          await createInvestorPartner({ document_number: formatCPFToNumber(data.document_number) })
          router.push('/feedback-cadastro')
        } else {
          await createInvestor(data)
          router.push('/feedback-cadastro')
        }
      } catch (error) {
        if (!!documentNumberRegistered && error.response.status === 400) {
          return toast.error('Usuário já investidor.')
        }
        toast.error('Ocorreu um erro ao tentar se cadastrar. Tente novamente.')
      }
    },
    [documentNumberRegistered]
  )

  const handleCpfCheck = useCallback(
    async cpf => {
      const sanitizedCpf = cpf.replace(/\D/g, '')

      try {
        if (sanitizedCpf.length === 11) {
          const response = await checkCpf(sanitizedCpf)

          if (response.have_user === true) {
            setdocumentNumberRegistered(response.have_user)
            toast.success('CPF já cadastrado, basta cadastrar.')
          } else {
            setdocumentNumberRegistered(response.have_user)
          }
        }
      } catch (error) {}
    },
    [setdocumentNumberRegistered, checkCpf]
  )

  useEffect(() => {
    handleCpfCheck(cpfValue)
  }, [cpfValue, handleCpfCheck])

  return (
    <Column alignItems='center' width='100%' paddingTop='16vh' pl={2} pr={2}>
      <NextSeo title='Kavod Lending - Cadastro de investidor' description='KavodLending | Peer to Peer lending' />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Column>
          <Text variant='h3'>Cadastro de investidor</Text>
          <NumberInput
            maxwidth={384}
            mb='40px !important'
            mt={4}
            id='document_number'
            name='document_number'
            inputType='cpf'
            control={control}
            error={errors.document_number}
          />
          {!documentNumberRegistered && (
            <>
              <Input
                maxwidth={384}
                mb='40px !important'
                id='first_name'
                label='Nome'
                name='first_name'
                placeholder='Nome'
                control={control}
                error={errors.first_name}
              />
              <Input
                maxwidth={384}
                mb='40px !important'
                id='last_name'
                label='Sobrenome'
                name='last_name'
                placeholder='Sobrenome'
                control={control}
                error={errors.last_name}
              />
              <Input
                maxwidth={384}
                mb='40px !important'
                id='email'
                label='Email'
                name='email'
                placeholder='Email'
                control={control}
                error={errors.email}
              />
              <PasswordInput
                maxwidth={384}
                mb='40px !important'
                id='password'
                name='password'
                control={control}
                error={errors.password}
                validationBox
              />
            </>
          )}

          <Button maxwidth={384} width='100%' mb='40px !important' type='submit' loader={isSubmitting}>
            Cadastrar
          </Button>

          <Text variant='body2' mb='40px !important' style={{ color: 'var(--gray)' }}>
            Já possui uma conta?{' '}
            <Link fontSize={14} href='/login'>
              Entrar
            </Link>
          </Text>
        </Column>
      </form>
    </Column>
  )
}

export default SignupInvestor
 */

import { Column } from '../src/components'

const SignupInvestor = () => {
  return <Column alignItems='center' width='100%' paddingTop='16vh' pl={2} pr={2}></Column>
}

export default SignupInvestor
